module.exports = __webpack_public_path__ + "static/media/operationdefinition.js.981f8eb1.map";